import * as z from 'zod';
import { contractDamageSchema, contractHazardSchema, usStateOrTerritorySchema } from '../../../../enums.mjs';
import { naicsCodeRowSchema } from '../../../naics-codes/naics-codes.mjs';
import { city } from '../../../opaque.mjs';
import { safeNumberSchema } from '../../../utils.mjs';

var Underwriting;
(function (Underwriting) {
    (function (Bond) {
        let Input;
        (function (Input) {
            Input.schema = z.object({
                completionBond: z.boolean().nullish(),
            });
        })(Input = Bond.Input || (Bond.Input = {}));
        Bond.baseSchema = z.object({
            modelVersion: z.string(),
            input: Input.schema,
        });
    })(Underwriting.Bond || (Underwriting.Bond = {}));
    (function (Project) {
        let Input;
        (function (Input) {
            Input.schema = z.object({
                name: z.string().min(1),
                projectNumber: z.string().nullish(),
                description: z.string(),
                address: z
                    .object({
                    city: city.nullish(),
                    state: usStateOrTerritorySchema.nullish(),
                })
                    .nullish(),
                scopeOfWork: z.array(naicsCodeRowSchema.partial({ id: true })),
                monthsToComplete: safeNumberSchema.min(1).nullable(),
                contractWarrantyMonths: safeNumberSchema.nonnegative().nullable(),
                contractHazards: z.array(contractHazardSchema).default([]),
                contractDamages: z.array(contractDamageSchema).default([]),
            });
        })(Input = Project.Input || (Project.Input = {}));
        let Calculations;
        (function (Calculations) {
            Calculations.schema = z.object({
                scopeFit: z.boolean(),
                projectMonthsToCompletePlusContractWarrantyMonths: z.number().nullish(),
            });
        })(Calculations = Project.Calculations || (Project.Calculations = {}));
        Project.schema = z.object({
            modelVersion: z.string(),
            input: Input.schema,
            calculations: Calculations.schema,
        });
    })(Underwriting.Project || (Underwriting.Project = {}));
})(Underwriting || (Underwriting = {}));

export { Underwriting };
